export default __webpack_public_path__ + "static/media/map.1c2af7c2.png";